const menuRouter = [
    /**
     * 系统管理
     **/

    {
        path: '/finance/accountingtitle',
        meta: { title: '会计科目' },
        component: () => import('@/views/page/finance/accountingtitle'),
        used: true,
    },
    {
        path: '/finance/voucher',
        meta: { title: '记账凭证' },
        component: () => import('@/views/page/finance/voucher'),
        used: true,
    },
    {
        path: '/finance/fee',
        meta: { title: '费用设置' },
        component: () => import('@/views/page/finance/fee'),
        used: true,
    },
    {
        path: '/finance/feebill',
        meta: { title: '费用单' },
        component: () => import('@/views/page/finance/feebill'),
        used: true,
    },
    {
        path: '/finance/nonbusinessin',
        meta: { title: '非营业外收入' },
        component: () => import('@/views/page/finance/nonbusinessin'),
        used: true,
    },
    {
        path: '/finance/nonbusinesspay',
        meta: { title: '非营业外支出' },
        component: () => import('@/views/page/finance/nonbusinesspay'),
        used: true,
    },
    {
        path: '/finance/purchasepay',
        meta: { title: '采购付款' },
        component: () => import('@/views/page/finance/purchasepay'),
        used: true,
    },
    {
        path: '/finance/salecollection',
        meta: { title: '销售收款' },
        component: () => import('@/views/page/finance/salecollection'),
        used: true,
    },
    {
        path: '/finance/collectionplan',
        meta: { title: '收款计划' },
        component: () => import('@/views/page/finance/collectionplan'),
        used: true,
    },
    {
        path: '/finance/collectionplanpay',
        meta: { title: '实际收款登记' },
        component: () => import('@/views/page/finance/collectionplanpay'),
        used: true,
    },
    {
        path: '/finance/paymentsummary',
        meta: { title: '采购待付款汇总查询' },
        component: () => import('@/views/page/finance/paymentsummary'),
        used: true,
    },
    {
        path: '/finance/paymentdetailed',
        meta: { title: '采购待付款明细查询' },
        component: () => import('@/views/page/finance/paymentdetailed'),
        used: true,
    },
    {
        path: '/finance/receivablesummary',
        meta: { title: '销售待收款汇总查询' },
        component: () => import('@/views/page/finance/receivablesummary'),
        used: true,
    },
    {
        path: '/finance/receivabledetailed',
        meta: { title: '销售待收款明细查询' },
        component: () => import('@/views/page/finance/receivabledetailed'),
        used: true,
    },
    {
        path: '/finance/billing',
        meta: { title: '账务查询' },
        component: () => import('@/views/page/finance/billing'),
        used: true,
    },
    {
        path: '/finance/accountbalance',
        meta: { title: '账尾查询' },
        component: () => import('@/views/page/finance/accountbalance'),
        used: true,
    },
    {
        path: '/finance/accountbook',
        meta: { title: '查看账本' },
        component: () => import('@/views/page/finance/accountbook'),
        used: true,
    },
    {
        path: '/finance/liabilities',
        meta: { title: '资产负债表' },
        component: () => import('@/views/page/finance/liabilities'),
        used: true,
    },
    {
        path: '/finance/profit',
        meta: { title: '利润表' },
        component: () => import('@/views/page/finance/profit'),
        used: true,
    },

]

export default menuRouter
